import { useMemo } from "react";

import { AlertValidationDecisionValues } from "src/types/alert";

import { useGetAlertDecisionLabel } from "./useGetAlertDecisionLabel";

export const useAlertValidationDecisions = () => {
  const getAlertDecisionLabel = useGetAlertDecisionLabel();
  const decisions = useMemo(
    () =>
      AlertValidationDecisionValues.map((decision) => ({
        id: decision,
        title: getAlertDecisionLabel(decision),
      })),
    [getAlertDecisionLabel]
  );

  return decisions;
};
